"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withFixedProps = exports.createDeepSelector = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = require("reselect");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createDeepSelector = exports.createDeepSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _lodash2.default.isEqual);
var withFixedProps = exports.withFixedProps = function withFixedProps(props1, selector) {
  return function (state, props0) {
    return selector(state, _extends({}, props0, props1));
  };
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9zZWxlY3QtdXRpbHMuanMiXSwibmFtZXMiOlsiY3JlYXRlRGVlcFNlbGVjdG9yIiwiaXNFcXVhbCIsIndpdGhGaXhlZFByb3BzIiwicHJvcHMxIiwic2VsZWN0b3IiLCJzdGF0ZSIsInByb3BzMCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQ0E7O0FBQ0E7Ozs7OztBQUVPLElBQU1BLGtEQUFxQiwrREFFaEMsaUJBQUVDLE9BRjhCLENBQTNCO0FBSUEsSUFBTUMsMENBQWlCLFNBQWpCQSxjQUFpQixDQUM1QkMsTUFENEIsRUFFNUJDLFFBRjRCO0FBQUEsU0FHekIsVUFBQ0MsS0FBRCxFQUFXQyxNQUFYO0FBQUEsV0FBNkJGLFNBQVNDLEtBQVQsZUFBb0JDLE1BQXBCLEVBQStCSCxNQUEvQixFQUE3QjtBQUFBLEdBSHlCO0FBQUEsQ0FBdkIiLCJmaWxlIjoic2VsZWN0LXV0aWxzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCB7Y3JlYXRlU2VsZWN0b3JDcmVhdG9yLCBkZWZhdWx0TWVtb2l6ZX0gZnJvbSBcInJlc2VsZWN0XCJcbmltcG9ydCBfIGZyb20gXCJsb2Rhc2hcIlxuXG5leHBvcnQgY29uc3QgY3JlYXRlRGVlcFNlbGVjdG9yID0gY3JlYXRlU2VsZWN0b3JDcmVhdG9yKFxuICBkZWZhdWx0TWVtb2l6ZSxcbiAgXy5pc0VxdWFsLFxuKVxuZXhwb3J0IGNvbnN0IHdpdGhGaXhlZFByb3BzID0gPFMsIFAwOiB7fSwgUDE6IHt9LCBPPihcbiAgcHJvcHMxOiBQMSxcbiAgc2VsZWN0b3I6IChTLCBQMCAmIFAxKSA9PiBPLFxuKSA9PiAoc3RhdGU6IFMsIHByb3BzMDogUDApOiBPID0+IHNlbGVjdG9yKHN0YXRlLCB7Li4ucHJvcHMwLCAuLi5wcm9wczF9KVxuIl19


//////////////////
// WEBPACK FOOTER
// ../core/lib/select-utils.js
// module id = 158
// module chunks = 0